<template>
  <label :class="$style.Label">
    <input v-model="state" :class="$style.Checkbox" type="checkbox" />
    {{ label }}
  </label>
</template>
<script>
import AsyncVModel from '../../mixins/async-vmodel';

export default {
  name: 'Checkbox',
  mixins: [AsyncVModel],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  }
};
</script>
<style
  lang="scss"
  src="../../scss/components/input/Checkbox.scss"
  module
></style>
